<template>
    <div>
        <h1>My {{ settings.appraisal }}s</h1>
        <div class="shadow p-3 mb-5 bg-white rounded">
            <b-table 
                striped 
                hover 
                :items="appraisals" 
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                :showEmpty="true"
                empty-text="None"
            >
                <template v-slot:cell(action)="data">
                    <b-icon-eye-fill cursor="pointer" @click="viewAppraisal(data.item)"></b-icon-eye-fill>
                </template>
                
            </b-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
            ></b-pagination>
        </div>
    </div>
</template>

<script>

    import moment from 'moment';
    import { mapGetters } from 'vuex'

    export default {
        name: 'ListAppraisals',
        computed: {
            rows() {
                return this.appraisals.length
            },
            ...mapGetters(['settings', 'appraisals'])
        },
        methods: {
            viewAppraisal (obj) {
                this.$store.commit('setcurrentappraisal', obj)
                this.$router.push('view')
            },
        },
        data() {
            return {
                perPage: 3,
                currentPage: 1,
                fields: [
                    {
                        key: 'startdate',
                        label: 'Start Date',
                        sortable: true,
                        formatter: (value) => {
                            return moment(value).format('DD/MM/YYYY')
                        },
                        sortByFormatted: true,
                        filterByFormatted: true
                    }, 
                    {
                        key: 'reviewdate',
                        label: 'Review Date',
                        sortable: true,
                        formatter: (value) => {
                            return moment(value).format('DD/MM/YYYY')
                        },
                        sortByFormatted: true,
                        filterByFormatted: true
                    }, 
                    {
                        key: 'action',
                        label: ''
                    }
                ]
            }
        }
    }
</script>